import styled from 'styled-components';

export const StyledTopMenuGroup = styled.ul`
	margin: 0;
	padding: 0.375rem 0;
	display: flex;
	flex-direction: row;
	height: 100%;
	gap: ${({ theme }) => theme.spacing.lg};
`;

export const TopbarMenuWrapper = styled.div`
	display: flex;
	height: 100%;
`;
